import Image from "common/components/Image";
import LinkButton from "common/components/LinkButton";

import { urls } from "client/routes";
import {
  useProductLinesViewOnVisible,
  useSendPostHogProductLineClick,
} from "client/analytics/utils";
import { ProductLineListSource } from "client/analytics/types";

import { ProductLineSummary } from "../types";
import CategoryBrowseRow from "./CategoryBrowseRow";

import styles from "../styles/ProductLineCarousel.module.less";

type ProductLineCarouselProps = {
  categoryId: number;
  productLines: ProductLineSummary[];
};

/** The product lines in the current results, best first, each linking to its page. */
const ProductLineCarousel = ({ categoryId, productLines }: ProductLineCarouselProps) => {
  const sendProductLineClick = useSendPostHogProductLineClick();
  const viewRef = useProductLinesViewOnVisible(
    productLines,
    ProductLineListSource.CategoryPageProductLines,
    categoryId,
  );

  if (!productLines.length) {
    return null;
  }

  return (
    <CategoryBrowseRow
      revealKey={null}
      firstCellRef={viewRef}
      items={productLines.map((productLine, position) => ({
        key: productLine.id,
        node: (
          <LinkButton
            className={styles.card}
            dest={urls.products.detail({ params: { id: productLine.id } })}
            onClick={() =>
              sendProductLineClick({
                source: ProductLineListSource.CategoryPageProductLines,
                id: productLine.id,
                category_id: categoryId,
                personalization_kind: null,
                position,
              })
            }
          >
            <div className={styles.image}>
              {productLine.image && (
                <Image
                  className={styles.imageMedia}
                  src={productLine.image}
                  alt=""
                  loading="lazy"
                />
              )}
            </div>
            <span className={styles.label}>{productLine.name}</span>
          </LinkButton>
        ),
      }))}
    />
  );
};

export default ProductLineCarousel;
